import { render, staticRenderFns } from "./ShopStorePayYinsheng.vue.vue?vue&type=template&id=2fb7753d&scoped=true"
import script from "./ShopStorePayYinsheng.vue.vue?vue&type=script&lang=js"
export * from "./ShopStorePayYinsheng.vue.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayYinsheng.vue.vue?vue&type=style&index=0&id=2fb7753d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7753d",
  null
  
)

export default component.exports